<template>
  <div>
    <header>
      <nav class="navbar navbar-inverse navbar-fixed-top" role="navigation" style="background-color: #611232;">
        <div class="container">
          <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                    data-target="#navbarMainCollapse">
              <span class="sr-only">Interruptor de Navegación</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" style="padding-left:6px;" href="https://www.gob.mx/"><img
                src="https://framework-gb.cdn.gob.mx/gobmx/img/logo_blanco.svg" width="75"
                height="23"
                alt="Página de inicio, Gobierno de México"></a>
          </div>
          <div class="collapse navbar-collapse" id="navbarMainCollapse">
            <ul class="nav navbar-nav navbar-right">
              <li><a href="https://www.gob.mx/tramites" title="Trámites" style="color: #fff;">Trámites</a></li>
              <li><a href="https://www.gob.mx/gobierno" title="Gobierno" style="color: #fff;">Gobierno</a></li>
              <li><a href="https://www.gob.mx/participa" title="Participación Ciudadana" style="color: #fff;">Participa</a>
              </li>
              <li><a href="https://datos.gob.mx" title="Datos Abiertos" style="color: #fff;">Datos</a></li>
            </ul>
          </div>
        </div>
      </nav>
      <nav class="navbar navbar-inverse sub-navbar navbar-fixed-top">
        <div class="container">
          <div class="navbar-header">
            <a class="navbar-brand custom-hover" href="/" >Módulo de servicios en el exterior
              <small>{{ versionApp }}</small>

            </a>
          </div>
        </div>
      </nav>
    </header>

    <div class="banner">
      <div style="padding: 15% 5%;color:white; width:50%;text-align: center">
        <img alt="SRE" src="/img/login/logo.png" style="margin: 5% 30%;" width="30%">
        <h2>MÓDULO DE SERVICIOS EN EL EXTERIOR
          <small>{{ versionApp }}</small>
        </h2>

      </div>
      <div class="form-container">
        <br>
        <el-row type="flex"
                justify="center">

          <el-col :md="14" :lg="12" :xl="6">
            <div class="login" style="border-radius: 10%"
                 :class="[requestAccessLoading === true  ? 'test' : '']">

              <div class='login_title'>
                <span>Inicio de Sesión</span>
              </div>
              <div class='login_fields'>
                <div class='login_fields__user'>
                  <el-input placeholder="Usuario" v-model="credentials.username" autocomplete="off"
                            type='text'>
                  </el-input>
                </div>
                <br>
                <div class='login_fields__password'>
                  <el-input
                      placeholder="Contraseña"
                      v-model="credentials.password"
                      autocomplete="off"
                      type='password'
                      @keyup.enter.native="requestAccess">
                  </el-input>
                </div>

                <div class='login_fields__submit'>
                  <button
                      type="button"
                      @click="requestAccess">
                    Entrar
                  </button>

                </div>
              </div>
              <div class='disclaimer'>
                <p>© 2022 - Secretaría de Relaciones Exteriores</p>
              </div>
            </div>
            <transition name="bounce">
              <div class="authent" v-if="requestAccessLoading === true" style="right: 0 !important;">
                <img src="/img/login/loading.svg">
                <p>Verificando...</p>
              </div>
            </transition>
          </el-col>
        </el-row>
      </div>
    </div>

    <footer class="main-footer" style="background-color: #611232;">
      <div class="list-info">
        <div class="container">
          <div class="row">
            <div class="col-sm-4"><h5>Enlaces</h5>
              <ul>
                <li><a href="http://reformas.gob.mx" target="_blank">Reformas</a></li>
                <li><a href="http://portaltransparencia.gob.mx" target="_blank">Portal de Obligaciones
                  de Transparencia</a></li>
                <li><a href="https://www.infomex.org.mx/gobiernofederal/home.action" target="_blank">Sistema
                  Infomex</a></li>
                <li><a href="http://inicio.ifai.org.mx/SitePages/ifai.aspx" target="_blank">INAI</a>
                </li>
              </ul>
            </div>
            <div class="col-sm-4"><h5>¿Qué es gob.mx?</h5>
              <p>Es el portal único de trámites, información y participación ciudadana. <a
                  href="https://www.gob.mx/que-es-gobmx">Leer más</a></p>
              <ul>
                <li><a href="https://www.gob.mx/en/index">English</a></li>
                <li><a href="https://www.gob.mx/temas">Temas</a></li>
                <li><a href="https://www.gob.mx/accesibilidad">Declaración de Accesibilidad</a></li>
                <li><a href="https://www.gob.mx/privacidadintegral">Aviso de privacidad integral</a>
                </li>
                <li><a href="https://www.gob.mx/privacidadsimplificado">Aviso de privacidad
                  simplificado</a></li>
                <li><a href="https://www.gob.mx/terminos">Términos y Condiciones</a></li>
                <li><a href="https://www.gob.mx/terminos#medidas-seguridad-informacion">Política de
                  seguridad</a></li>
                <li><a href="http://www.ordenjuridico.gob.mx" target="_blank">Marco Jurídico</a></li>
                <li><a href="https://www.gob.mx/sitemap">Mapa de sitio</a></li>
              </ul>
            </div>
            <div class="col-sm-4"><h5>Contacto</h5>
              <p>Mesa de ayuda: dudas e información <br> gobmx@funcionpublica.gob.mx</p>
              <p><a
                  href="https://www.gob.mx/tramites/ficha/presentacion-de-quejas-y-denuncias-en-la-sfp/SFP54">Denuncia
                contra servidores públicos</a></p></div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <form role="form" id="subscribete">
                <fieldset>
                  <legend class="vh">Suscríbete</legend>
                  <label for="email">Mantente informado. Suscríbete.</label>
                  <div class="form-group-icon"><input type="text" class="form-control" id="email"
                                                      name="email"
                                                      aria-label="Ingresa tu correo electrónico"
                                                      placeholder="usuario@ejemplo.com">
                    <button id="subscribe" type="button" class="blue-right btn"><span class="vh">Suscríbete</span><i
                        class="icon-caret-right"></i></button>
                  </div>
                  <div class="message-subscribe hidden"></div>
                </fieldset>
              </form>
            </div>
            <div class="col-sm-4 col-sm-offset-4"><h5>Síguenos en</h5>
              <ul class="list-inline">
                <li>
                    <a class="social-icon facebook" target="_blank"
                      href="https://www.facebook.com/gobmx" 
                      aria-label="Facebook de presidencia" style="color: #000;">
                        <i class="fab fa-facebook"></i>
                    </a>
                </li>
                <li>
                    <a class="social-icon twitter" target="_blank" 
                      href="https://twitter.com/gobmx"
                      aria-label="Twitter de presidencia">
                        <i class="fab fa-twitter"></i>
                    </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-4">
            <img class="gobmx-footer"
                 src="https://framework-gb.cdn.gob.mx/gobmx/img/logo_blanco.svg"
                 width="126" height="39" alt="Página de inicio, Gobierno de México">
          </div>
          <div class="col-sm-4 col-sm-offset-4"></div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      credentials: {
        username: '',
        password: '',
      },
      requestAccessLoading: false,
      verisonApp: ''
    }
  },


  created() {

    this.versionApp = window.versionApp
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    let var_key = params.get("key");
    let var_token = params.get("token");
    if (var_key && var_token && var_key != '' && var_token != '') {
      axios.post('/api/login?key=' + var_key + '&token=' + var_token, this.credentials).then(response => {

        this.requestAccessLoading = false;

        if (response.data.authenticated === true) {

          window.sessionStorage.setItem('acquisition_token', response.data.acquisition_token);
          window.sessionStorage.setItem('acquisition_token_expiration', response.data.acquisition_token_expiration);
          window.sessionStorage.setItem('acquisition_user', response.data.acquisition_user);
          window.sessionStorage.setItem('user', JSON.stringify(response.data.user));

          window.sessionStorage.setItem('acquisition_session_time', response.data.acquisition_session_time);
          window.sessionStorage.setItem('acquisition_session_message', response.data.acquisition_session_message);

          window.sessionStorage.removeItem('acquisition_splash');

          if (window.sessionStorage.getItem('acquisition_token')) {
            window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.sessionStorage.getItem('acquisition_token');
          }

          this.$store.commit('setUser', response.data.user);
          this.$router.push('/');

        } else {

          window.location = 'https://intgra.sre.gob.mx';
          this.requestAccessLoading = false;

        }

      }).catch(err => {

        window.location = 'https://intgra.sre.gob.mx';
        this.requestAccessLoading = false;


      });
    }


  },


  methods: {
    validateUserAndPassword(value) {
      if (value && value !== '') {
        return {'opacity': 1};
      } else {
        return {'opacity': 0};
      }
    },
    requestAccess() {
      this.requestAccessLoading = true;
      if (this.credentials.username.length === 0 || this.credentials.password.length === 0) {
        this.requestAccessLoading = false;
        this.$store.dispatch('notifications/warning',
            {msg: 'El campo de usuario y contraseña son obligatorios.'}, {root: true});

        return false;
      }

      setTimeout(() => {

        axios.post('/api/login', this.credentials).then(response => {

          this.requestAccessLoading = false;

          if (response.data.authenticated === true) {

            window.sessionStorage.setItem('acquisition_token', response.data.acquisition_token);
            window.sessionStorage.setItem('acquisition_token_expiration', response.data.acquisition_token_expiration);
            window.sessionStorage.setItem('acquisition_user', response.data.acquisition_user);
            window.sessionStorage.setItem('user', JSON.stringify(response.data.user));

            window.sessionStorage.setItem('acquisition_session_time', response.data.acquisition_session_time);
            window.sessionStorage.setItem('acquisition_session_message', response.data.acquisition_session_message);

            window.sessionStorage.removeItem('acquisition_splash');

            if (window.sessionStorage.getItem('acquisition_token')) {
              window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.sessionStorage.getItem('acquisition_token');
            }

            this.$store.commit('setUser', response.data.user);
            this.$router.push('/');

          } else {
            this.requestAccessLoading = false;

            this.$message({
              type: 'warning',
              message: 'Usuario o contraseña incorrecta, inténtelo nuevamente.'
            });
          }

        }).catch(err => {
          console.log(err);
          this.requestAccessLoading = false;

          this.$message({
            type: 'warning',
            message: 'Usuario o contraseña incorrecta, inténtelo nuevamente.'
          });
        });

      }, 2500);
    },

  }
}
</script>

<style scoped>
@import '/css/gob.css';

.banner {
  background-image: url('/img/login/home2.png');
  background-repeat: no-repeat;
  background-size: cover;
  height: 800px;
  width: 100%;
}


.bounce-enter-active {
  animation: bounce-in .5s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

html, body {
  height: 100%;
  font-family: 'Montserrat', sans-serif;
}

.system-name {
  text-align: center;
  padding-bottom: 1em;
}

.form-wrapper {
  height: 100vh;
}

.main-form {
  width: 50%;
  position: relative;
  background-color: #e6d194;
}

.form-container {
  position: relative;
  left: 50%;
  top: -45%;
  width: 50%;
}

.image {
  width: 100%;
  display: block;
}

.backgroung-image {

  width: 50% !important;
  /*
        background: url('/img/loginBackground/1.jpg') no-repeat center center fixed;*/
  background-image: url('/img/loginBackground/sre.jpg');
  background-repeat: no-repeat;

  background-size: cover;

  height: 100vh;
  overflow: hidden;
}

.authent {
  background: transparent;
  position: absolute;
  left: 0;
  right: 90px;
  margin: auto;
  width: 100px;
  color: #fff;
  letter-spacing: 1px;
  text-align: center;

  top: 200px;
  bottom: 0;
  height: 70px;
  opacity: 1;
}

.authent p {
  text-align: center;
  color: #fff;
}

.disclaimer > p {
  text-align: center;
  color: white;
  font-size: 10px;
}

.test {
  pointer-events: none;
  opacity: .6 !important;
  -webkit-filter: blur(1px);
  filter: blur(1px);
}

.login {

  opacity: 1;
  top: 20px;
  -webkit-transition-timing-function: cubic-bezier(0.68, -0.25, 0.265, 0.85);
  -webkit-transition-property: opacity, top, left, -webkit-transform, -webkit-box-shadow;
  transition-property: opacity, top, left, -webkit-transform, -webkit-box-shadow;
  transition-property: transform, opacity, box-shadow, top, left;
  transition-property: transform, opacity, box-shadow, top, left, -webkit-transform, -webkit-box-shadow;
  -webkit-transition-duration: .5s;
  transition-duration: .5s;
  -webkit-transform-origin: 161px 100%;
  transform-origin: 161px 100%;
  -webkit-transform: rotateX(0deg);
  transform: rotateX(0deg);
  position: relative;
  width: 340px;
  /*border-top: 2px solid #9D2449;*/
  height: 400px;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 0;
  bottom: 0;
  padding: 100px 40px 40px 40px;
  background: transparent; /*35394a;*/
  /*background: linear-gradient(45deg, #e6d194 0%, #B38E5D 100%);*/
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#434A54', endColorstr='#1f222e', GradientType=1);


  /* -webkit-box-shadow: 3px 7px 5px 0px rgba(212,193,156,1);
-moz-box-shadow: 3px 7px 5px 0px rgba(212,193,156,1);
box-shadow: 3px 7px 5px 0px rgba(212,193,156,1);*/
}

.login .validation {
  position: absolute;
  z-index: 1;
  right: 10px;
  top: 6px;
  /*  opacity: 1;*/
}

.login .disclaimer {
  position: absolute;
  bottom: -25px;
  left: 2px;
  width: 350px;
}

.login .disclaimer > p {
  margin-top: 30px;
  text-align: center;
}

.login_title {
  color: white !important;
  height: 60px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}

.login_verification {
  color: #eaeaee;
  height: auto;
  text-align: center;
  font-size: 13px;
}

.login_fields {
  height: 208px;
  position: absolute;
  left: 0;
  width: 100%;
}

.login_fields .icon {
  position: absolute;
  z-index: 1;
  left: 36px;
  top: 8px;
  opacity: .5;
}

.login_fields input[type='text'],
.login_fields input[type='password'] {
  text-align: center;
  color: #9D2449;
  width: 100%;
  margin-top: -2px;
  background: white;
  left: 0;
  padding: 10px 65px;
  border-top: 2px solid #B38E5D;
  border-bottom: 2px solid #B38E5D;
  border-left: 2px solid #B38E5D;
  border-right: 2px solid #B38E5D;
  border-right: none;
  border-left: none;
  outline: none;
  font-family: 'Montserrat', sans-serif;
  -webkit-box-shadow: none;
  box-shadow: none;

}

.login_fields__user, .login_fields__password {
  position: relative;
}

.login_fields__submit {
  position: relative;
  top: 35px;
  left: 0;
  width: 80%;
  right: 0;
  margin: auto;
  text-align: center;
}

.login_fields__submit button {
  border-radius: 50px;
  background: transparent;
  padding: 10px 50px;
  border: 2px solid #B38E5D;
  color: white;
  text-transform: uppercase;
  font-size: 11px;
  -webkit-transition-property: background, color;
  transition-property: background, color;
  -webkit-transition-duration: .2s;
  transition-duration: .2s;
}

.login_fields__submit button:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
}

.login_fields__submit button:hover {
  color: #fff;
  background: #B38E5D;
  border-color: #B38E5D;
  cursor: pointer;
  -webkit-transition-property: background, color;
  transition-property: background, color;
  -webkit-transition-duration: .2s;
  transition-duration: .2s;
}


.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.languages-dropdown {
  text-align: right;
}

.pass-recovery {
  font-size: 10px;
  text-align: center;
  color: #fff;
  cursor: pointer;
}

.custom-hover:hover {
    color: #611232; /* Cambia el color del texto al pasar el mouse */
}
</style>


login.vue
